import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IFilter } from 'codex-lib';
import { EnvelopeFilter } from '../model/envelope-filter';
import { FiltersEnvelope } from '../model/filters-envelope';

const CREATION = 'creation';
const EXPIRATION = 'expiration';
const CONCLUTION = 'conclution';
const SEGMENT = 'segment';
const CREATOR = 'creator';

@Injectable({
  providedIn: 'root',
})
export class EnvelopeFiltersService {
  dateRange: any;

  constructor(
    private translate: TranslateService) { }


  getFilterOptions(filtersEnvelope?: FiltersEnvelope): IFilter {
    return {
      datePickerContainer: [
        {
          title: CREATION,
          icon: {
            prefix: 'fas',
            iconName: 'calendar-alt'
          },
          placeholder: 'codex.datePickerComponent.datePickerPlaceholderRange'
        },
        {
          title: EXPIRATION,
          icon: {
            prefix: 'fas',
            iconName: 'hourglass-half'
          },
          placeholder: 'codex.datePickerComponent.datePickerPlaceholderRange'
        },
        {
          title: CONCLUTION,
          icon: {
            prefix: 'fas',
            iconName: 'hourglass-half'
          },
          placeholder: 'codex.datePickerComponent.datePickerPlaceholderRange'
        }
      ],
      dropdownContainer: [
        {
          title: SEGMENT,
          icon: {
            prefix: 'fas',
            iconName: 'users-cog',
          },
          dropdown: {
            showSearch: true,
            clearSelectionItem: true,
            items: this.listSegment(filtersEnvelope),
            displayText: 'nomeDoItem'
          }
        },
        {
          title: CREATOR,
          icon: {
            prefix: 'fas',
            iconName: 'inbox',
          },
          dropdown: {
            showSearch: true,
            clearSelectionItem: true,
            items: this.listEnvelopeCreator(filtersEnvelope),
            displayText: 'nomeDoItem'
          }
        }
      ]
    };
  }

  listSegment(filtersEnvelope?: FiltersEnvelope): Array<any> {
    let segmentList;
    if (filtersEnvelope === undefined) {
      return [];
    }

    if (filtersEnvelope.listSegment && filtersEnvelope.listSegment.length > 0) {
      segmentList = filtersEnvelope.listSegment
        .map((x) => ({
          title: SEGMENT,
          nomeDoItem: x.name,
          codigo: -1,
          id: x.id
        }));

      segmentList.unshift({
        title: SEGMENT,
        nomeDoItem: this.translate.instant('envelope.list.noSegment'), codigo: -1, id: -1
      });

      return segmentList;
    } else {
      return [];
    }
  }

  listEnvelopeCreator(filtersEnvelope?: FiltersEnvelope): Array<any> {
    let envelopeCreatorList;
    if (filtersEnvelope === undefined) {
      return envelopeCreatorList;
    }

    if (filtersEnvelope.listEnvelopeCreator && filtersEnvelope.listEnvelopeCreator.length > 0) {

      envelopeCreatorList = filtersEnvelope.listEnvelopeCreator
        .map((x) => ({
          title: CREATOR,
          nomeDoItem: x.userName,
          codigo: -2,
          id: x.id
        }));

      return envelopeCreatorList;
    } else {
      return [];
    }
  }

  applyFilter(
    filters: Array<any>
  ): EnvelopeFilter {
    const envelopeFilter = new EnvelopeFilter();

    if (!filters || (filters && filters.length === 0)) {
      return envelopeFilter;
    }

    filters.forEach((filter) => {
      switch (filter.title) {
        case CREATION:
          envelopeFilter.creationDateRange = this.onDate(filter);
          break;
        case EXPIRATION:
          envelopeFilter.expirationDateRange = this.onDate(filter);
          break;
        case CONCLUTION:
          envelopeFilter.conclutionDateRange = this.onDate(filter);
          break;
        case undefined:
          if (filter.selectedItem && filter.selectedItem.title) {
            switch (filter.selectedItem.title) {
              case SEGMENT:
                envelopeFilter.segmentsIds=[];
                envelopeFilter.segmentsIds.push(filter.selectedItem.id);
                break;
              case CREATOR:
                envelopeFilter.creatorIds = filter.selectedItem.id;
                envelopeFilter.creatorUserName = filter.selectedItem.nomeDoItem;
                break;
            }
          }
          break;
      }
    });

    return envelopeFilter;
  }

  onDate(date) {
    if (date) {
      this.dateRange = {
        beginDate: new Date(date.dateRange.beginDate.year, date.dateRange.beginDate.month - 1, date.dateRange.beginDate.day),
        endDate: new Date(date.dateRange.endDate.year, date.dateRange.endDate.month - 1, date.dateRange.endDate.day)
      };
      return this.dateRange;
    }
    return null;
  }

}
